<div class="date-picker-container">
    <!-- Wrapper del input con el placeholder dentro -->
    <div class="date-picker-wrapper">
        <div class="date-input-wrapper">
            <input
                [value]="formattedDate"
                (click)="openDatePicker()"
                readonly
                [disabled]="disabled"
                [placeholder]="placeholder"
                class="date-input" />
        </div>

        <div class="underline"></div>
    </div>

    <!-- Modal para seleccionar año y mes -->
    <div
        class="modal fade"
        [class.show]="showDatePicker"
        [style.display]="showDatePicker ? 'block' : 'none'">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Seleccionar fecha</h5>
                    <button
                        type="button"
                        class="close"
                        (click)="closeDatePicker()">
                        <span>&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="selectors-container">
                         <!-- Selector de Año -->
                         <div class="year-selector">
                            <div class="form-group mb-0">
                                <label for="anios" class="form-label">Año:</label>
                                <select
                                    id="anios"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedYear"
                                    (change)="onYearSelect()"
                                    [disabled]="disabled">
                                    <option
                                        *ngFor="let year of years"
                                        [ngValue]="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Selector de Mes -->
                        <div class="month-selector">
                            <div class="form-group mb-0">
                                <label for="months-date" class="form-label">Mes:</label>
                                <select
                                    id="months-date"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedMonth"
                                    [disabled]="disabled">
                                    <option
                                        *ngFor="let month of availableMonths"
                                        [ngValue]="month.number">
                                        {{ month.name }}
                                    </option>
                                </select>
                            </div>                        
                        </div>

                       
                    </div>
                    
                    <div class="button-container">
                        <button
                            class="btn btn-primary btn-sm"
                            (click)="selectDate()">
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fondo oscuro del modal -->
    <div
        class="modal-backdrop fade"
        [class.show]="showDatePicker"
        [style.display]="showDatePicker ? 'block' : 'none'"></div>
</div>